import React, { useState } from "react";
import RowComponent from "./RowComponent";
import { useNavigate } from "react-router-dom";
import { API_URL } from "../../../config";

const PracticumTable = ({ sesstion, practicumData, selectedClient }) => {
  const extractPracticumId = (practicumString) => {
    if (!practicumString) return null;
    const match = practicumString.match(/\(Pr-(\d+)\)/);
    return match ? `Pr-${match[1]}` : null;
  };
  const accessToken = localStorage.getItem("accessToken");
  const navigate = useNavigate();
  const [loader, setLoader] = useState(null);

  if (selectedClient === "Choose a client") {
    return (
      <div className="practicum-container" style={{ marginTop: "20px" }}>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100%",
            padding: "20px",
            backgroundColor: "#f8f9fa",
            borderRadius: "8px",
          }}
        >
          <p
            style={{
              fontSize: "16px",
              color: "#6c757d",
              textAlign: "center",
            }}
          >
            Please select a client to view the practicum data.
          </p>
        </div>
      </div>
    );
  }

  if (practicumData.filter((p) => p.practicum?.length).length === 0) {
    return (
      <div className="practicum-container" style={{ marginTop: "20px" }}>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100%",
            padding: "20px",
            backgroundColor: "#f8f9fa",
            borderRadius: "8px",
          }}
        >
          <p
            style={{
              fontSize: "16px",
              textAlign: "center",
            }}
          >
            No practicum data available for the selected client.
          </p>
        </div>
      </div>
    );
  }

  const createMultiSessions = (selectedSessions, id) => {
    console.log(selectedSessions, "selectedSessions");

    let data = {
      signals: ["pco2wave"],
      session: selectedSessions,
    };
    setLoader(id);
    fetch(API_URL + "/create/multi/session", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": accessToken,
      },
      body: JSON.stringify(data),
    })
      .then((response) => {
        if (response.status == 200) {
          setLoader(false);
          response.json().then((result) => {
            if (result.status) {
              navigate("/view/multi/report/1/0/" + result.rid + "?practicum=1");
            } else {
              alert("no data error");
            }
          });
        } else if (response.status == 401) {
          setLoader(null);
        } else {
          setLoader(null);
          console.log("network error");
        }
      })
      .catch((err) => {
        setLoader(null);
        console.log("network error");
      });
  };

  return (
    <div className="practicum-container">
      <table className="practicum-table">
        <thead>
          <tr>
            <th className="column-practicum">Practicum</th>
            <th className="column-objective">Objective</th>
            <th className="column-score">Score</th>
            <th className="column-icons action">Action</th>
          </tr>
        </thead>
        <tbody>
          {practicumData
            .filter((p) => p.practicum?.length)
            .map((item, index) => {
              const filteredSessions = sesstion
                .filter((session) => {
                  const practicumId = extractPracticumId(session.practicum);
                  return practicumId === item.pId;
                })
                .map((session) => ({
                  ...session,
                  practicumId: extractPracticumId(session.practicum),
                }));

              return (
                <RowComponent
                  key={item.id}
                  index={item?.id}
                  item={item}
                  filteredSessions={filteredSessions}
                  practicumId={item.pId}
                  createMultiSessions={(selectedSessions, id) =>
                    createMultiSessions(selectedSessions, id)
                  }
                  loader={loader}
                />
              );
            })}
        </tbody>
      </table>

      <style jsx>{`
        .practicum-container {
          max-width: 100%;
          overflow-x: auto;
          margin-top: 20px;
        }

        .practicum-table {
          width: 100%;
          border-collapse: separate;
          border-spacing: 0 20px;
        }

        .practicum-table thead {
          border-bottom: 1px solid #ddd;
        }

        .practicum-table th {
          text-align: left;
          padding: 0 4px;
          color: #a0a0a0;
          font-weight: normal;
          font-size: 14px;
        }

        .practicum-table tbody tr {
          background-color: #ffffff;
          border-top-left-radius: 25px;
          border-bottom-left-radius: 25px;
          box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
          transition: background-color 0.3s ease;
          height: 5px;
        }

        .practicum-table td {
          vertical-align: middle;
        }

        .column-objective {
          width: 38%;
          padding: 0 3px;
          color: #212529;
        }

        .column-score {
          width: 40%;
          text-align: center !important;
        }
        .column-score-value {
          padding: 0 16px;
          text-align: center;
          display: flex;
          align-items: center;
          justify-content: center;
          margin: 10px auto;
        }

        .column-icons {
          width: 10%;
        }

        .column-practicum-tr {
          padding: 0px 5px;
          color: #212529;
        }

        .practicum-number {
          background-color: #efe5f0;
          border-top-left-radius: 8px;
          border-bottom-left-radius: 8px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-weight: bold;
          color: #800080;
          font-size: 16px;
          width: 70%; /* Make it a square */
          height: 40px;
        }

        .icons-container {
          display: flex;
          gap: 10px;
          margin-left: auto;
          padding: 8px 15px;
          background-color: #efe5f0;
          width: fit-content;
          border-top-right-radius: 8px;
          border-bottom-right-radius: 8px;
        }

        .icon {
          font-size: 18px;
          cursor: pointer;
          color: #6b4c90;
        }

        @media (max-width: 768px) {
          .practicum-container {
            overflow-x: auto;
            display: block;
            white-space: nowrap; /* Prevents wrapping */
          }

          .practicum-table {
            min-width: 600px; /* Adjust this value as needed */
          }
          .practicum-table th {
            padding: 8px;
            font-size: 12px;
          }

          .practicum-table td {
            padding: 12px 8px;
          }

          .icons-container {
            gap: 8px;
          }

          .icon {
            font-size: 16px;
          }

          .column-score-value {
            width: 200px;
          }
        }
      `}</style>
    </div>
  );
};

export default PracticumTable;
